import { ChangeEvent, useEffect, useState } from 'react';
import { InputProps } from 'react-select';
import styled from 'styled-components';
import { BouColor } from '../../../../../../generic/global/bou-colors';
import { components } from 'react-select';

interface CustomInputProps extends InputProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

export function CustomInput(props: InputProps<any>) {
  const castProps = props as CustomInputProps;

  const [underlineWidth, setUnderlineWidth] = useState(0);
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  const [inputRef, setInputRef] = useState<HTMLInputElement | null>(null);

  function catchRef(ref: HTMLInputElement | null) {
    setInputRef(ref);
    props.innerRef?.(ref);
  }

  useEffect(() => {
    const current = inputRef;
    if (!current || !context) {
      return;
    }

    // The font properties used for the input text are checked from DOM, and an
    // invisible dummy text with similar values is measured with HTML canvas to check
    // its length. NOTE: probably will not work correctly with letter-spacing, as it is not a property
    // of the css 'font' -shorthand.
    const fontProperties = ['font-style', 'font-variant', 'font-weight', 'font-size', 'font-family'];
    context.font = fontProperties
      .map(property => `${window.getComputedStyle(current).getPropertyValue(property)}`)
      .join(' ');

    const textToMeasure = castProps.value.length ? castProps.value : undefined;
    if (textToMeasure) {
      const width = context.measureText(textToMeasure).width;
      setUnderlineWidth(width);
    } else {
      setUnderlineWidth(0);
    }
  }, [castProps.value, context, inputRef]);

  return (
    <Root>
      <StyledInput {...props} id="search-input" innerRef={catchRef} role="searchbox" />
      {castProps.value && <Underline underlineWidth={underlineWidth} />}
    </Root>
  );
}

const Root = styled.div`
  position: relative;
`;

const StyledInput = styled(components.Input)`
  color: ${BouColor.BLACK};
  background-color: transparent;
  width: 100%;
  max-width: 100%;
`;

const Underline = styled.div<{ underlineWidth: number }>`
  width: ${props => (props.underlineWidth ? props.underlineWidth + 3 : 0)}px;
  border-top: 1px solid ${BouColor.BLACK};
  height: 1px;
  position: absolute;
  max-width: 100%;
`;
